import { Button, Title } from '@qonsoll/react-design'
import {
  useActionsEditorAdvancedForm,
  useInitializeEditorAdvancedForm
} from './hooks'

import { EditorSimpleForm } from 'domains/Editor/components'
import { Form } from 'antd'
import { NewspaperSelect } from 'domains/Newspaper/components'
import PropTypes from 'prop-types'
import { useCheckChangeFormValue } from 'hooks'
import { useTranslations } from 'contexts/Translation'

const EditorAdvancedForm = (props) => {
  const { initialData, group, showTitle, ...rest } = props

  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting form instance from hook */
  const { form } = useInitializeEditorAdvancedForm(initialData)

  /* Getting loading state and actions from hook */
  const { loading, onFinish, onReset, handleKeyPress } =
    useActionsEditorAdvancedForm({
      initialData,
      form
    })

  const { triggerValueChange, isEqualForms } =
    useCheckChangeFormValue(initialData)

  const isDisableNewspaperSelect = !!initialData?.newspaper?._id

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Editor')}
        </Title>
      )}
      <EditorSimpleForm
        showTitle={false}
        group={[...group, 'editor']}
        {...rest}
      />
      <Form.Item name={[group, 'newspaper']}>
        <NewspaperSelect />
      </Form.Item>
    </>
  ) : (
    <Form
      onKeyPress={handleKeyPress}
      onFinish={onFinish}
      layout="vertical"
      autoComplete="off"
      onValuesChange={triggerValueChange}
      form={form}>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Editor')}
        </Title>
      )}
      <EditorSimpleForm
        group={['editor']}
        initialValues={initialData}
        {...rest}
      />
      <Form.Item
        name={['newspaper']}
        rules={[{ required: true, message: t('Please choose a newspaper') }]}>
        <NewspaperSelect disabled={isDisableNewspaperSelect} />
      </Form.Item>

      <Button mr={2} htmlType="button" onClick={onReset}>
        {t('Cancel')}
      </Button>
      <Button
        type="primary"
        disabled={isEqualForms}
        loading={loading}
        onClick={() => form.submit()}>
        {t('Save')}
      </Button>
    </Form>
  )
}

EditorAdvancedForm.propTypes = {
  initialData: PropTypes.object,
  group: PropTypes.array,
  showTitle: PropTypes.bool
}

export default EditorAdvancedForm
